import type { PiletApi } from '@chess/platform-web';
import { STORAGE_API } from '@chess/api-storage';
import { DexieStorage } from './dexie-storage';

// Provides `storage` over IndexedDB. Asks the browser to keep the data
// rather than evict it under pressure; nothing changes if it says no.
export function setup(app: PiletApi) {
  app.registerApi(STORAGE_API, new DexieStorage());
  navigator.storage?.persist?.().catch(() => undefined);
}
